// src/features/reports/components/Reports/components/ReportsHeader.jsx
import React from 'react';
import styles from '../Reports.module.css';

export default function ReportsHeader({
  filters,
  loading,
  reportData,
  onGenerate,
  onExport,
  onPrint,
}) {
  return (
    <div className={styles.pageHead}>
      <div>
        <h1 className={styles.pageTitle}>لوحة التقارير المالية</h1>
        <p className={styles.pageSub}>
          {filters.start_date} — {filters.end_date}
        </p>
      </div>

      <div className={styles.headActions}>
        <button
          className={styles.btnOutline}
          onClick={onExport}
          disabled={!reportData}
        >
          تصدير Excel
        </button>
        <button
          className={styles.btnOutline}
          style={{ borderColor: 'var(--color-info-border)', color: 'var(--color-info-text)' }}
          onClick={onPrint}
          disabled={!reportData}
        >
          طباعة PDF
        </button>
        <button
          className={styles.btnPrimary}
          onClick={onGenerate}
          disabled={loading}
        >
          {loading ? 'جاري التحميل…' : 'توليد التقرير'}
        </button>
      </div>
    </div>
  );
}